export const onHeaderActionClick = (
  key: string,
  quoteId: number,
  createProjectFromQuote: () => void,
  convertQuoteIntoInvoice: (quoteId: number) => void,
  downloadQuotePdf: (quoteId: number) => void,
  navigateToProject: () => void,
  navigateToInvoice: () => void
) => {
  switch (key) {
    case 'convert_to_project':
      return createProjectFromQuote()
    case 'go_to_project':
      return navigateToProject()
    case 'convert_to_invoice':
      return convertQuoteIntoInvoice(Number(quoteId))
    case 'go_to_invoice':
      return navigateToInvoice()
    case 'download_quote':
      return downloadQuotePdf(quoteId)
    case 'open_preview':
      return
  }
}
